import * as React from "react";
import { cn } from "../../lib/utils";

const PageHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex min-w-0 flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between mb-6",
      className
    )}
    {...props}
  />
));
PageHeader.displayName = "PageHeader";

const PageHeaderTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      "min-w-0 break-words text-2xl font-semibold tracking-tight text-text-primary",
      className
    )}
    {...props}
  />
));
PageHeaderTitle.displayName = "PageHeaderTitle";

const PageHeaderDescription = React.forwardRef(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn("text-sm text-text-tertiary mt-1", className)}
      {...props}
    />
  )
);
PageHeaderDescription.displayName = "PageHeaderDescription";

const PageHeaderActions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex min-w-0 max-w-full flex-wrap items-center gap-2", className)}
    {...props}
  />
));
PageHeaderActions.displayName = "PageHeaderActions";

export { PageHeader, PageHeaderTitle, PageHeaderDescription, PageHeaderActions };
